import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <circle
      cx={24}
      cy={24}
      r={24}
      style={{
        fill: "#060b0c",
        strokeWidth: 0,
      }}
    />
    <path
      d="M30 12 18 24l12 12"
      style={{
        fill: "none",
        stroke: "#00a4b7",
        strokeMiterlimit: 10,
        strokeWidth: 2,
      }}
    />
  </svg>
)
export default SvgComponent
